var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweetners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.00001C9.79087 8.00001 8.00001 9.79087 8.00001 12C8.00001 14.2091 9.79087 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79087 14.2091 8.00001 12 8.00001ZM6.00001 12C6.00001 8.6863 8.6863 6.00001 12 6.00001C15.3137 6.00001 18 8.6863 18 12C18 15.3137 15.3137 18 12 18C8.6863 18 6.00001 15.3137 6.00001 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11C10.5523 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15C10.3432 15 9.00001 13.6568 9.00001 12C9.00001 11.4477 9.44772 11 10 11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73641 1.0677C8.09557 1.18712 8.35653 1.49907 8.41064 1.87368L9.33349 8.26331C9.37856 8.57537 9.27382 8.89042 9.05087 9.11337C8.82791 9.33632 8.51287 9.44106 8.20081 9.39599L1.81118 8.47314C1.43657 8.41903 1.12462 8.15807 1.0052 7.79891C0.885788 7.43974 0.979386 7.04394 1.24702 6.7763L6.7138 1.30952C6.98144 1.04189 7.37724 0.948288 7.73641 1.0677ZM4.07273 6.77902L7.16282 7.22532L6.71652 4.13523L4.07273 6.77902Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9492 14.9492C15.1721 14.7262 15.4871 14.6215 15.7992 14.6665L22.1889 15.5894C22.5635 15.6435 22.8754 15.9044 22.9948 16.2636C23.1142 16.6228 23.0207 17.0186 22.753 17.2862L17.2862 22.753C17.0186 23.0207 16.6228 23.1142 16.2636 22.9948C15.9044 22.8754 15.6435 22.5635 15.5894 22.1889L14.6665 15.7992C14.6215 15.4871 14.7262 15.1721 14.9492 14.9492ZM16.8372 16.8372L17.2835 19.9273L19.9273 17.2835L16.8372 16.8372Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweetners);
export default __webpack_public_path__ + "static/media/sweetners.e20e288ec2d810d7bc6ca0b8f0861886.svg";
export { ForwardRef as ReactComponent };